import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { useFetcher } from '../useGetFetchConfig';
import { DeletionStatusResponse } from '@/api/types/backend-dto-types';

const POLL_INTERVAL_MS = 4000;

/**
 * Polls the in-progress deletion (if any) for a matter. Refetches every 4s while either the
 * deletion job or the post-deletion summary-regeneration run is still in flight; stops when
 * both are idle to keep quiet pages quiet.
 */
export const useGetDeletionStatus = (matterId: string) => {
  const fetcher = useFetcher();

  return useQuery<DeletionStatusResponse>(
    [QueryEntity.DeletionStatus, { matterId }],
    () => fetcher(`${APIBaseChronos}/api/run/matter/${matterId}/deletion-status`),
    {
      enabled: !!matterId,
      refetchOnWindowFocus: true,
      refetchInterval: (data) => (data?.inProgress != null || data?.hasPostDeletionRun ? POLL_INTERVAL_MS : false),
    },
  );
};
